export default __webpack_public_path__ + "static/media/syndi_dialog.0be98089.png";